import SharingLinkInfo from '../store/schema/SharingLinkInfo';
import { LinkActionStatus } from '../types/LinkActionStatus';
import { getSharingUrls } from '../utils/getSharingUrls';
import { getSupportedPermissionLevels } from '../utils/getSupportedPermissionLevels';
import { getAttachmentPermissionLevelFromSharingLinkKind } from 'owa-attachment-permission';
import { userDate } from 'owa-datetime/lib/userDate';
import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';
import AttachmentResultCode from 'owa-service/lib/contract/AttachmentResultCode';
import GetSharingInfoResponse from 'owa-service/lib/contract/GetSharingInfoResponse';

export function createLinkModel(
    linkId: string,
    url: string,
    response: GetSharingInfoResponse | null
): SharingLinkInfo {
    if (!response || response.ResultCode !== AttachmentResultCode.Success) {
        return {
            linkId: linkId,
            fileName: null,
            mimeType: null,
            url: url,
            permissionLevel: AttachmentPermissionLevel.None,
            sharingInfo: {
                getSharingInfoSucceeded: false,
                canonicalUrl: '',
                canShareInternally: false,
                canShareExternally: false,
                expirationDate: null,
                canRefresh: false,
                shareId: null,
                recipientPermissionInfos: [],
                hasDLRecipient: false,
            },
            supportedPermissionLevels: null,
            sharingUrls: null,
            sharingTipsIgnored: [],
            linkActionStatus: LinkActionStatus.none,
        };
    }

    return {
        linkId: linkId,
        fileName: response.FileName,
        mimeType: response.MimeType,
        url: url,
        permissionLevel: getAttachmentPermissionLevelFromSharingLinkKind(response.SharingLinkKind),
        sharingInfo: {
            getSharingInfoSucceeded: true,
            canonicalUrl: response.CanonicalUrl,
            canShareInternally: response.CanShareInternally,
            canShareExternally: response.CanShareExternally,
            expirationDate: response.ExpirationDate ? userDate(response.ExpirationDate) : null,
            canRefresh: response.CanCreateAnonymousEditLink || response.CanCreateAnonymousViewLink,
            shareId: null,
            recipientPermissionInfos: [],
            hasDLRecipient: false,
        },
        supportedPermissionLevels: getSupportedPermissionLevels(response),
        sharingUrls: getSharingUrls(response),
        sharingTipsIgnored: [],
        linkActionStatus: LinkActionStatus.none,
    };
}
